import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';

const Home = lazy(() => import('./pages/Home'));
const CharacterCounter = lazy(() => import('./pages/CharacterCounter'));
const Png2Pdf = lazy(() => import('./pages/Png2Pdf'));
const YoutubeThumbnail = lazy(() => import('./pages/YoutubeThumbnail'));
const BarChart = lazy(() => import('./pages/BarChart'));
const DatabaseViewer = lazy(() => import('./pages/DatabaseViewer'));
const Contact = lazy(() => import('./pages/Contact'));
const About = lazy(() => import('./pages/About'));
const Privacy = lazy(() => import('./pages/Privacy'));

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <Helmet>
          <link rel="icon" type="image/x-icon" href="/favicon.ico" />
          <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
        </Helmet>
        <Header />
        <main>
          <Suspense fallback={<div style={{padding: '40px 20px', textAlign: 'center'}}>読み込み中...</div>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/character-counter" element={<CharacterCounter />} />
              <Route path="/png2pdf" element={<Png2Pdf />} />
              <Route path="/thumbnail-downloader" element={<YoutubeThumbnail />} />
              <Route path="/bar-chart" element={<BarChart />} />
              <Route path="/database-viewer" element={<DatabaseViewer />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/about" element={<About />} />
              <Route path="/privacy" element={<Privacy />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;

